<template>
<sticky v-if="notifier"
        :disabled="!sticky"
        sticky-area="step"
        :add-fixed-top="addFixedTop"
        :z-index="1"
        @fixed="fixed => sticked = fixed">
    <div class="odr-notifier">
        <div class="odr-notifier__content" :class="{'odr-notifier__content_sticked': sticked}">
            <div class="odr-notifier__body">
                <icon v-if="notifier.icon">{{ notifier.icon }}</icon>
                <tpl :content="notifier.title"/>
            </div>
            <div v-if="notifier.buttons" class="odr-notifier__controls">
                <button v-for="button in notifier.buttons"
                        :key="button.title"
                        type="button"
                        class="odr-button-link odr-button-link_bold"
                        @click="button.handler">
                    {{ button.title }}
                </button>
            </div>
        </div>
    </div>
</sticky>
</template>

<script>
/* {
    stateId: String,
    title: String,
    icon?: String,
    autoHide?: Boolean,
    timeout?: Number || 3000 // ms,
    buttons: [{
        title: String,
        handler: Function
    }, ...]
} */
import '@/scss/blocks/notifier.scss';
import '@/scss/blocks/button-link.scss';

import sticky from '@/vue/markup/sticky.vue';
import { notifierBus } from '@/utils/notifier';
import tplVue from '@/vue/markup/tpl.vue';

export default {
    props: {
        addFixedTop: {
            type: Number,
            default: 0,
        },
        stateId: {
            type: String,
            required: true,
        },
        sticky: {
            type: Boolean,
            default: true,
        },
    },
    data () {
        return {
            notifier: undefined,
            sticked: false,
        };
    },
    created () {
        notifierBus.$on('show', this.onShow);
        notifierBus.$on('hide', this.onHide);
    },
    destroyed () {
        notifierBus.$off('show', this.onShow);
        notifierBus.$off('hide', this.onHide);
    },
    methods: {
        onHide (stateId) {
            if (stateId !== this.stateId) {
                return;
            }

            this.notifier = undefined;
        },
        onShow (options) {
            if (options.stateId !== this.stateId) {
                return;
            }

            this.notifier = options;
            if (options.autoHide) {
                setTimeout(() => {
                    notifierBus.$emit('hide', options.stateId);
                }, options.timeout || 3000);
            }
        },
    },
    components: {
        sticky,
        icon: require('@clearwave/odoro-markup/lib/vue/icon.vue').default,
        tpl: tplVue,
    },
};
</script>
